export const useCollection = () => {
    const getCollectionNode = (form, collection, parent = false, objType = false) => {
        const nested = (data, index = 0) => {
            // El if es para que no pete analiticas
            if (Object.keys(form).length !== 0 && data) {
                if (index === collection.length) return objType ? { ...data } : data
                if (parent) return data[collection[index]]
                return nested(data[collection[index]], ++index)
            } else {
                return {}
            }
        }
        if (!collection || collection.length === 0) {
            if (!form) return objType ? {} : []
            return form
        }
        return nested(form)
    }

    return { getCollectionNode }
}